import { usePageTopBar } from '@/app/layouts/pageTopBar';
import type { DocTab } from '../types';
import { DocumentCenter } from '../DocumentCenter';

export function DocumentCenterPage({ tab = 'documents' }: { tab?: DocTab }) {
  usePageTopBar({ breadcrumb: ['Document Center'] });
  return <DocumentCenter tab={tab} />;
}
